/**
 * Нижня навігація телефона (< 600 px, layout.md, розд. 3; телефон — Next, UX-47): ті самі
 * основні розділи, що в рейці, і розділи з її «Ще». «Налаштування» сюди не йдуть — адмінка лише на ПК.
 *
 * Один рядок (`<OverflowRow>`, components.md, розд. 12): що не вміщується, — у «Ще · N»; відкритий
 * розділ з «Ще» стає в рядок останнім (аудит якості № 15: сім пунктів ішли у два ряди за край).
 */
import { useNavigate, useRouterState } from '@tanstack/react-router';
import { shell as t } from '../i18n/uk/shell.ts';
import { Icon } from '../ui/Icon.tsx';
import { OverflowRow } from '../ui/OverflowRow.tsx';
import { NavLink } from './NavLink.tsx';
import { isCurrentNav, type ShellNav } from './nav-model.ts';

export const BOTTOM_NAV_ID = 'app-bottom-nav';

export function BottomBar({ nav }: { nav: ShellNav }) {
  const navigate = useNavigate();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const entries = [...nav.items, ...(nav.more ?? [])];
  const current = entries.find((item) => isCurrentNav(item, pathname));
  return (
    <OverflowRow
      as="nav"
      id={BOTTOM_NAV_ID}
      className="bottombar"
      label={t.navLabel}
      tabIndex={-1}
      selected={current?.id ?? null}
      items={entries.map((item) => ({
        key: item.id,
        name: item.label,
        node: <NavLink item={item} />,
        menu: [
          {
            kind: 'radio',
            id: item.id,
            label: item.label,
            checked: item === current,
            onSelect: () => void navigate({ to: item.to }),
          },
        ],
      }))}
      moreLabel={() => t.navMoreLabel}
      more={() => (
        <>
          <Icon name="more" size={20} />
          <span className="nav__label">{t.navMore}</span>
        </>
      )}
      moreClassName="bottombar__more"
    />
  );
}
